<template>
  <section class="content">
    <div class="box box-info">

      <div class="p-toolbar p-component mb-4">
        <button class="p-button p-component p-button-help exportBtn width-auto" type="button" @click.prevent="exportCSV()" v-if="this.incomeMasterLists.length > 0">
            <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
            <span class="p-ink"></span>
          </button>
          <incomeaccountdialog ref="openDialog"/>
        </div>


      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
         
         
          <DataTable ref="po"
                     :value="incomeMasterLists"
                     :rowsPerPageOptions="[100,500,1000]" :paginator="true" :rows="100"
                     :filters="filters"
                     class="p-datatable-responsive p-datatable-gridlines"
          >
            <Column header="S.n">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>
            <Column :sortable="true"
                    header="Group" headerStyle="width: 16em"
                    field="accountHeadName"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountHeadName']"/>
              </template>
            </Column>
            <Column :sortable="true"
                    header="Sub Group"
                    field="accountSubHeadName"
                    filterField="accountSubHeadName"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountSubHeadName']"/>
              </template>
            </Column>
            <Column :sortable="true" headerStyle="width: 15em" header="Name" field="name" filterMatchMode="contains">

              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Short Name"
                    field="shortName"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['shortName']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Opn Balance"
                    field="openingBalance"
                    filterMatchMode="contains"
                    bodyStyle="text-align: right"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingBalance']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Dr-Cr"
                    field="openingDrCr"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingDrCr']"/>
              </template>
            </Column>
            <Column :sortable="true"
                    header="Status"
                    field="status"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['status']"/>
              </template>
            </Column>
            <Column header="Action"  >
              <template #body="slotProps">


                <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                        @click="updateIncomeAccount(slotProps.data)"/>

                <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                        @click="openDialog(slotProps.data.id)"/>

              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountMaster"/>
  </section>
</template>
<script>
import incomeaccountdialog from '../accountDialog/IncomeAccountDialog.vue'
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import globalKey from '../../../store/globalKey'
import Column from 'primevue/column'
import Button from 'primevue/button'

export default {
  name: 'accountMaster',
  data() {
    return {
      dialogShow: false,
      columnList: '',
      filters: {},
      accountSubGroupLists: []
    }
  },
  computed: {
    incomeMasterLists() {
      return this.$store.state.accountMaster.incomeAccountLists
    }
  },
  mounted() {
    this.incomeMasterList()
    this.columnNames()
  },
  methods: {
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Supplier List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'supplierList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async incomeMasterList() {
      await this.$store.dispatch('loadIncomeAccountList')
    },
    updateIncomeAccount(data) {
      this.$refs.openDialog.updateIncomeAccount(data)
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(data) {
      this.accountId = data
      this.dialogShow = true
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    },
    closeDialog() {
      this.dialogShow = false
    },
    async deleteAccountMaster(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteIncomeMaster', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.closeDialog()
    }
  },
  components: {
    Dialog,
    Column,
    InputText,
    DataTable,
    incomeaccountdialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// incomeAccount.vue?262dee8f